<template>

<ul class="color-picker" v-if="localColors && Object.keys(localColors).length > 0 && !disable">
	<li :class="[ localSelected == index ? 'selected' : null, $lightOrDark(color) ]" v-for="(color, index) in localColors" @click="$emit('colorClick', index)">
		<!-- {{ index }} -->
		<i class="fas fa-check-square" :style="{ color: color }" v-if="localSelected === index"></i>
		<i class="fas fa-square" :style="{ color: color }" v-else></i>
	</li>
</ul>

<ul class="color-picker" v-else>
	<li class="disabled" v-for="(color, index) in localColors">
		<i class="fas fa-square" :style="{ color: color }"></i>
	</li>
</ul>

</template>

<script>
export default {
	name: 'color-picker',
	props: [ 'selected', 'colors', 'disable', 'rgb' ],
	data() {
		return {
			localDisable: false,
			localSelected: null
		}
	},
	mounted() {
		this.localSelected = this.selected
        //console.log(this.colors, this.selected)
	},
	watch: {
		disable(newVal) {
			this.localDisable = newVal
		},
		selected: {
            handler: function(newVal) {
				//console.log(newVal)
    			this.localSelected = newVal
    		},
            immediate: true
        }
	},
	computed: {
		localColors() {
			if (!this.colors) return []

			var colors = []
			for (var key in this.colors) {
				colors.push("rgba(" + this.colors[key] + ",1)")
			}
			return colors
		}
	},
	methods: {
		iconStyle(color) {
			return { color: "rgba(" + color + ",1)"}
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
